/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountConstraint } from './AccountConstraint';
import {
    AccountConstraintFromJSON,
    AccountConstraintFromJSONTyped,
    AccountConstraintToJSON,
} from './AccountConstraint';
import type { CashAllocation } from './CashAllocation';
import {
    CashAllocationFromJSON,
    CashAllocationFromJSONTyped,
    CashAllocationToJSON,
} from './CashAllocation';
import type { ConvictionAllocation } from './ConvictionAllocation';
import {
    ConvictionAllocationFromJSON,
    ConvictionAllocationFromJSONTyped,
    ConvictionAllocationToJSON,
} from './ConvictionAllocation';
import type { GrowthAllocation } from './GrowthAllocation';
import {
    GrowthAllocationFromJSON,
    GrowthAllocationFromJSONTyped,
    GrowthAllocationToJSON,
} from './GrowthAllocation';
import type { SecuredAllocation } from './SecuredAllocation';
import {
    SecuredAllocationFromJSON,
    SecuredAllocationFromJSONTyped,
    SecuredAllocationToJSON,
} from './SecuredAllocation';

/**
 * 
 * @export
 * @interface AccountAllocation
 */
export interface AccountAllocation {
    /**
     * 
     * @type {string}
     * @memberof AccountAllocation
     */
    accountGuid: string;
    /**
     * 
     * @type {AccountConstraint}
     * @memberof AccountAllocation
     */
    accountConstraint?: AccountConstraint;
    /**
     * 
     * @type {Array<CashAllocation>}
     * @memberof AccountAllocation
     */
    cashAllocation: Array<CashAllocation>;
    /**
     * 
     * @type {Array<SecuredAllocation>}
     * @memberof AccountAllocation
     */
    securedAllocation: Array<SecuredAllocation>;
    /**
     * 
     * @type {Array<ConvictionAllocation>}
     * @memberof AccountAllocation
     */
    convictionAllocation: Array<ConvictionAllocation>;
    /**
     * 
     * @type {Array<GrowthAllocation>}
     * @memberof AccountAllocation
     */
    growthAllocation: Array<GrowthAllocation>;
}

/**
 * Check if a given object implements the AccountAllocation interface.
 */
export function instanceOfAccountAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountGuid" in value;
    isInstance = isInstance && "cashAllocation" in value;
    isInstance = isInstance && "securedAllocation" in value;
    isInstance = isInstance && "convictionAllocation" in value;
    isInstance = isInstance && "growthAllocation" in value;

    return isInstance;
}

export function AccountAllocationFromJSON(json: any): AccountAllocation {
    return AccountAllocationFromJSONTyped(json, false);
}

export function AccountAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountGuid': json['account_guid'],
        'accountConstraint': !exists(json, 'account_constraint') ? undefined : AccountConstraintFromJSON(json['account_constraint']),
        'cashAllocation': ((json['cash_allocation'] as Array<any>).map(CashAllocationFromJSON)),
        'securedAllocation': ((json['secured_allocation'] as Array<any>).map(SecuredAllocationFromJSON)),
        'convictionAllocation': ((json['conviction_allocation'] as Array<any>).map(ConvictionAllocationFromJSON)),
        'growthAllocation': ((json['growth_allocation'] as Array<any>).map(GrowthAllocationFromJSON)),
    };
}

export function AccountAllocationToJSON(value?: AccountAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_guid': value.accountGuid,
        'account_constraint': AccountConstraintToJSON(value.accountConstraint),
        'cash_allocation': ((value.cashAllocation as Array<any>).map(CashAllocationToJSON)),
        'secured_allocation': ((value.securedAllocation as Array<any>).map(SecuredAllocationToJSON)),
        'conviction_allocation': ((value.convictionAllocation as Array<any>).map(ConvictionAllocationToJSON)),
        'growth_allocation': ((value.growthAllocation as Array<any>).map(GrowthAllocationToJSON)),
    };
}

